import {useState, useEffect} from 'react';
import Box from '@mui/material/Box';
import Popover from '@mui/material/Popover';
//import Grid from '@mui/material/Grid';
import { Button, Card, CardContent, CardMedia, Grid, IconButton, Pagination, Typography } from '@mui/material';
import { BiX } from "react-icons/bi";
import parse from 'html-react-parser';

function ProviderPopover(props) {
    const [position, setPosition] = useState({
        top: window.innerHeight * 0.1,
        left: window.innerWidth * 0.1,
    });
    const [page, setPage] = useState(1);
    const handlePageChange = (event, value) => {
        setPage(value);
    };

    const updatePosition = () => {
        setPosition({
        top: window.innerHeight * 0.1,
        left: window.innerWidth * 0.1,
        });
    };

    useEffect(() => {
        window.addEventListener('resize', updatePosition);
        return () => {
        window.removeEventListener('resize', updatePosition);
        };
    }, []);

    const handleClose = () => {
        props.setActiveResult(null);
    };

    const getTechProviderName = (id) => {
        if (props.techProviders && props.techProviders.length > 0) {
            let tp = props.techProviders.find(o => o.id === id);
            if (tp) {
                return tp.name;
            }
        }
        return "";
    };

    const handleApproval = async () => {
        const { error } = await props.db
            .schema('api')
			.from('tech_providers')
            .update({ approved: true })
            .eq('id', props.activeResult.id)

        if (props.setRefreshList) {
            props.setRefreshList(true);
        }

        props.setActiveResult(null);
    };

    return (
        <Popover 
        open={Boolean(props.activeResult)}
        onClose={handleClose}
        anchorReference="anchorPosition"
        anchorPosition={{ top: position.top, left: position.left }}
        slotProps={{
          paper: {
            sx: {
              width: '80vw',   // 80% of viewport width
              backgroundColor: '#F1F1F1',
            },
          },
        }}
      >
    {props.activeResult &&
    <Grid container spacing={2} sx={{padding:2}}>
        <Grid size={12} >
            <Box sx={{width:'100%'}}>
                <IconButton
                    size="large"
                    color="inherit"
                    onClick={() => handleClose()}
                    sx={{float: 'right'}}
                >
                <BiX />
                </IconButton>
            </Box>
        </Grid>
        <Grid size={{xs:12, sm:6, md:6, lg:6 }}>
            <Card sx={{ display: "flex", flexDirection: 'column', width: '100%', height: '100%', boxShadow: '5px 5px 5px 5px rgba(0, 0, 0, 0.25)', borderRadius: 0 }}>
                <CardContent sx={{ padding: 1, height: "100%", overflow: "hidden"}}>

                <Box sx={{display: 'flex', padding: '5px'}}>
                    <CardMedia
                        component="img"
                        sx={{ width: 100 }}
                        image={props.activeResult.logo}
                        alt="Logo"
                    />
                    <Typography variant="h5" sx={{paddingLeft: '10px'}}>
                        {props.activeResult.name}
                    </Typography>
                </Box>
                <Typography variant="body2" color="textSecondary" sx={{whiteSpace: 'pre-wrap', paddingTop: '5px'}}>
                    What we do:{<br/>}
                </Typography>
                <Typography variant="body1">
                    {props.activeResult.summary}
                </Typography>
                <Typography variant="body2" color="textSecondary" sx={{whiteSpace: 'pre-wrap', paddingTop: '5px'}}>
                    Location:{<br/>}
                </Typography>
                <Typography variant="body1">
                    {props.activeResult.location}
                </Typography>
                <Typography variant="body2" color="textSecondary" sx={{whiteSpace: 'pre-wrap', paddingTop: '5px'}}>
                    Technologies provided:{<br/>}
                </Typography>
                <Typography variant="body1">
                    {props.activeResult.technology_types?.join(", ")}
                </Typography>
                <Typography variant="body2" color="textSecondary" sx={{whiteSpace: 'pre-wrap', paddingTop: '5px'}}>
                    Sectors served:{<br/>}
                </Typography>
                <Typography variant="body1">
                    {props.activeResult.sectors?.join(", ")}
                </Typography>
                <Typography variant="body2" color="textSecondary" sx={{whiteSpace: 'pre-wrap', paddingTop: '5px'}}>
                    SDGs:{<br/>}
                </Typography>
                <Typography variant="body1">
                    {props.activeResult.sdgs?.map((s) => <img key={`sdg${s}`} style={{padding: '2px'}} width="50px" src={`/sdg${s}.png`}/>)}
                </Typography>
                </CardContent>
            </Card>
            </Grid>
            <Grid size={{xs:12, sm:6, md:6, lg:6 }}>
            <Card sx={{ display: "flex", flexDirection: 'column', width: '100%', height: '100%', boxShadow: '5px 5px 5px 5px rgba(0, 0, 0, 0.25)', borderRadius: 0 }}>
                <CardContent sx={{ padding: 1, height: "100%", overflow: "hidden"}}>
                {props.activeResult.image_urls && props.activeResult.image_urls.length > 0 &&
                <div>
                <CardMedia
                    component="img"
                    sx={{ maxHeight: "50vh", objectFit: "contain" }}
                    image={props.activeResult.image_urls[page-1]}
                    alt="Project image"
                />
                {props.activeResult.image_urls.length > 1 &&
                <Pagination count={props.activeResult.image_urls.length} page={page} onChange={handlePageChange} />}
                </div>}
                </CardContent>
            </Card>
            </Grid>
            <Grid size={{xs:12, sm:6, md:6, lg:6 }}>
            <Card sx={{ display: "flex", flexDirection: 'column', width: '100%', height: '100%', boxShadow: '5px 5px 5px 5px rgba(0, 0, 0, 0.25)', borderRadius: 0 }}>
                <CardContent sx={{ padding: 1, height: "100%", overflow: "hidden"}}>
                <Typography variant="body2" color="textSecondary" sx={{whiteSpace: 'pre-wrap', paddingTop: '5px'}}>
                    Description:{<br/>}
                </Typography>
                <Typography variant="body1" component="div">
                    {parse(props.activeResult.description)}
                </Typography>
                </CardContent>
            </Card>
            </Grid>
            <Grid size={{xs:12, sm:6, md:6, lg:6 }}>
            <Card sx={{ display: "flex", flexDirection: 'column', width: '100%', height: '100%', boxShadow: '5px 5px 5px 5px rgba(0, 0, 0, 0.25)', borderRadius: 0 }}>
                <CardContent sx={{ padding: 1, height: "100%", overflow: "hidden"}}>
                    <Typography variant="body2" color="textSecondary" sx={{whiteSpace: 'pre-wrap', paddingTop: '5px'}}>
                        Contact:{<br/>}
                    </Typography>
                    <Typography variant="body1">
                        {props.activeResult.contact}
                    </Typography>
                    <Typography variant="body2" color="textSecondary" sx={{whiteSpace: 'pre-wrap', paddingTop: '5px'}}>
                        Website:{<br/>}
                    </Typography>
                    <Typography variant="body1">
                        <a href={props.activeResult.website} target='_blank' rel='noreferrer'>{props.activeResult.website}</a>
                    </Typography>
                    <Typography variant="body2" color="textSecondary" sx={{whiteSpace: 'pre-wrap', paddingTop: '5px'}}>
                        Social media:{<br/>}
                    </Typography>
                    {props.activeResult.social_media ? props.activeResult.social_media?.map((sm) => (
                        <Typography variant="body1" key={`social${props.activeResult.social_media.indexOf(sm)}`}>
                            <a href={sm} target='_blank' rel='noreferrer'>{sm}</a>
                        </Typography>
                    )) : 
                        <Typography variant="body1">
                            None
                        </Typography>
                    }
                    <Typography variant="body2" color="textSecondary" sx={{whiteSpace: 'pre-wrap', paddingTop: '5px'}}>
                        Publications, reports, and other links:{<br/>}
                    </Typography>
                    {props.activeResult.documents ? props.activeResult.documents?.map((doc) => (
                        <Typography variant="body1" key={`doc${doc.link}`}>
                            <a href={doc.link} target='_blank' rel='noreferrer'>{doc.name}</a>
                        </Typography>
                    )) : 
                        <Typography variant="body1">
                            None
                        </Typography>
                    }
                </CardContent>
            </Card>
            </Grid>
        </Grid>
        }
        {props.admin === true && (
            <Button onClick={handleApproval} variant="contained" size="small">Approve</Button>
        )}
      </Popover>
    );
}

export default ProviderPopover;